import {
    FETCH_DATA_SENDED_REQUEST,
    FETCH_DATA_SENDED_SUCCESS,
    FETCH_DATA_SENDED_FAILURE,
} from '../../actions/connection/connection-sended-actions';

const initialState = {
    data: {},
    isLoading: false,
    error: null,
};

const ConnectionSendedReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_SENDED_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_SENDED_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data:action.payload,
            };
        case FETCH_DATA_SENDED_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default ConnectionSendedReducer;